<div class="explain-question" *ngIf="data.title !== undefined">
  <h5 [innerHTML]="data.title" *ngIf="data.title.length > 0"
      [ngClass]="{'default-text': !data.includeTitle}"></h5>
  <div class="question-block" *ngFor="let answer of answers; let i = index">
    <div class="question-label radio"
         [ngClass]="{'selected': answer.id === valueSelected, 'disabled': !active}"
         (click)="setValueSelected(answer.id)">
      <i class="radio-icon"></i>
      <span [innerHTML]="i === 0 ? answer.value + data.name : answer.value"></span>
    </div>
  </div>
  <div class="default-text">
    They are only valid in
    <span class="select-layer" [ngClass]="{'disabled': !active || valueSelected !== '1'}">
      <select class="app-select" [disabled]="!active || valueSelected !== '1'"
              (change)="setValidationSelected($event.target.value)">
        <option [value]="validation.id" *ngFor="let validation of filteredValidations()"
                [selected]="validationSelected === validation.id">
          {{validation.value}}
        </option>
      </select>
    </span>
  </div>
  <div class="default-text">
    Type a short explanation.<br />
    <strong>Example:</strong> {{data.exampleItem}}
    are only valid in the signposted bays in Whitchurch Road.
  </div>
  <form>
    <textarea class="app-textarea" [disabled]="!active || valueSelected !== '2'"
              (change)="validationText = $event.target.value; onAnswerSelected()">{{validationText}}</textarea>
  </form>
</div>
